export enum ServiceProvider {
  None = 0,
  FedEx = 1,
  OmniTracs = 2,
  Ryder = 3,
  Idelic = 4,
  Lytx = 5,
  PeopleNet = 6,
  OmniTracsXRS = 7,
  NHTS = 8,
  BlackBook = 9,
  PriceDigest = 10,
  ReportAll = 11,
  Motive = 12,
  Twilio = 13,
  Microsoft = 14
}

export const ServiceMapping: Record<ServiceProvider, string> = {
  [ServiceProvider.None]: 'None',
  [ServiceProvider.FedEx]: 'FedEx (MGB Login)',
  [ServiceProvider.OmniTracs]: 'OmniTracs',
  [ServiceProvider.Ryder]: 'Ryder',
  [ServiceProvider.Idelic]: 'Idelic',
  [ServiceProvider.Lytx]: 'Lytx',
  [ServiceProvider.PeopleNet]: 'PeopleNet',
  [ServiceProvider.OmniTracsXRS]: 'OmniTracs XRS',
  [ServiceProvider.NHTS]: 'NHTS',
  [ServiceProvider.BlackBook]: 'Black Book',
  [ServiceProvider.PriceDigest]: 'Price Digest',
  [ServiceProvider.ReportAll]: 'Report All',
  [ServiceProvider.Motive]: 'Motive',
  [ServiceProvider.Twilio]: 'Twilio',
  [ServiceProvider.Microsoft]: 'Microsoft'
};

export const ServicesProvidersForSystem = [
  ServiceProvider.NHTS,
  ServiceProvider.BlackBook,
  ServiceProvider.ReportAll,
  ServiceProvider.PriceDigest,
  ServiceProvider.Twilio,
  ServiceProvider.Microsoft
];

export const ServicesProvidersHosHistorical = [ServiceProvider.Motive, ServiceProvider.OmniTracsXRS];
export const ServicesProvidersGpsHistorical = [ServiceProvider.Motive, ServiceProvider.OmniTracsXRS];
